module.exports = __webpack_public_path__ + "assets/5410cdd11b1f4cd447958aa108b40e19.jpg";